import "./Skills.css";

function Skills() {
  return (
    <div className="skills" id="skills">
        <section>
            <nav>
                <h1>HTML5</h1>
                <p>A year+ experience</p>
            </nav>
            <nav>
                <h1>CSS3</h1>
                <p>A year+ experience</p>
            </nav>
            <nav>
                <h1>JavaScript</h1>
                <p>A year+ experience</p>
            </nav>
            <nav>
                <h1>React</h1>
                <p>A year+ experience</p>
            </nav>
            <nav>
                <h1>Framer Motion</h1>
                <p>A year+ experience</p>
            </nav>
            <nav>
                <h1>Sass</h1>
                <p>A year+ experience</p>
            </nav>
            <nav>
                <h1>NodeJs</h1>
                <p>A year+ experience</p>
            </nav>
            <nav>
                <h1>MongoDB</h1>
                <p>A year+ experience</p>
            </nav>
            <nav>
                <h1>ExpressJs</h1>
                <p>A year+ experience</p>
            </nav>
            <nav>
                <h1>PostgreSQL</h1>
                <p>A year+ experience</p>
            </nav>
        </section>
    </div>
  );
}

export default Skills;